import { StringHelpers } from "../helpers/string-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { IComponent } from "./component.interface";
import { InformationPopupComponent } from "./information-popup.component";
import { PnlComponent } from "./pnl.component";

export class EarningNotificationComponent implements IComponent {
    public id = StringHelpers.newGuid();

    private element: HTMLElement;
    private base: IChartContainer;
    private resizeTimer: any;
    private text = '';
    
    constructor(element: HTMLElement, base: IChartContainer) {
        this.element = element;
        this.base = base;
        this.subscribeEarningNotification();
        this.onSymbolClick();
        this.onResize();
    }

    public show() {
        this.element.removeClass('hidden');
        this.checkPnlBox();
    }

    public hide() {
        this.element.addClass('hidden');
        this.checkPnlBox();
    }

    private checkPnlBox() {
        const comp = this.base.getComponentsByType(PnlComponent)?.[0] as PnlComponent;
        if (comp) {
            comp.addOneClass();
        }
    }

    private updateText(text: string) {
        this.element.findFirst('.text')?.setInnerHtml(text);
        this.element.findFirst('.symbol')?.ifExistThen((el: HTMLElement) => {
            el.setAttribute('title', StringHelpers.replaceHTMLTag(text));
        });
        if (text) {
            this.show();
        }

        this.text = text;
        this.handleESymbol();
    }

    private subscribeEarningNotification() {
        this.base.chartService.subscribeEarningNotificationData((data: string) => {
            this.updateText(data);
        });
    }

    private handleESymbol() {
        this.element.findFirst('.symbol')?.addClass('hidden');
        this.element.findFirst('.text')?.removeClass('hidden');
        this.element.findFirst('.text')?.addClass('vh');

        const windowWidth = this.base.tiChartSeries.element.clientWidth;
        const elementWidth = this.element.clientWidth;
        const pnlComponent = this.base.getComponentsByType(PnlComponent)[0] as PnlComponent;
        const otherComponentsWidth = (pnlComponent?.element.clientWidth ?? 0 ) + 90;
        const shouldShowE = elementWidth + otherComponentsWidth > windowWidth;

        if (shouldShowE) {
            this.element.findFirst('.symbol')?.removeClass('hidden');
            this.element.findFirst('.text')?.addClass('hidden');
        } else {
            this.element.findFirst('.text')?.removeClass('hidden');
            this.element.findFirst('.symbol')?.addClass('hidden');
        }

        this.element.findFirst('.text')?.removeClass('vh');
    }

    private onSymbolClick() {
        if (this.base.isTouchDevice && this.base.marketingWebChartMode) {
            this.element.findFirst('.symbol')?.addEventListener('click', () => {
                const popup = this.base.getComponentsByType(InformationPopupComponent)[0] as InformationPopupComponent;
                popup?.show(`Earnings`, this.text);
            }); 
        }
    }

    private onResize() {
        this.base.domEvents.onResize(this.id, () => {
            clearTimeout(this.resizeTimer);
            this.resizeTimer = setTimeout(() => {
                this.handleESymbol();
            }, 200);
        });
    }
}